// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const DynatraceIntelligenceSignetIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon
      data-iconname="DynatraceIntelligenceSignetIcon"
      ref={forwardedRef}
      {...props}
    >
      <path d="M17 11.84a58 58 0 0 0-.12-3.213c-.128-1.904-.393-3.874-.396-3.898-.064-.438-.398-.787-.811-.854-.119-.022-1.879-.354-3.847-.588a52 52 0 0 0-3.187-.282H8.624l.002-.002a1.6 1.6 0 0 0-1.21.46L7.15 3.718a1914 1914 0 0 0-3.642 3.48C2.983 7.712 2.998 8.558 3 8.647c0 .017.034 1.774.114 2.964a56 56 0 0 0 .396 3.875.994.994 0 0 0 .807.89 55 55 0 0 0 3.863.596 62 62 0 0 0 1.945.183l1.308.095h.035a1.6 1.6 0 0 0 1.116-.457l.166-.16 1.037-.997c1.051-1.01 2.357-2.265 2.696-2.588a1.6 1.6 0 0 0 .514-1.209zM7.644 6.667 7.218 6.562l.426-.106a1.6 1.6 0 0 0 1.187-1.262L8.948 4.56l.119.634a1.6 1.6 0 0 0 1.187 1.262l.426.106-.426.106a1.6 1.6 0 0 0-1.187 1.26L8.948 8.565 8.831 7.929a1.6 1.6 0 0 0-1.187-1.261m3.903 4.31a1.6 1.6 0 0 0-1.186 1.261l-.118.635-.117-.635a1.6 1.6 0 0 0-1.186-1.26l-.427-.107.427-.106a1.6 1.6 0 0 0 1.186-1.261l.117-.635.118.635a1.6 1.6 0 0 0 1.186 1.26l.427.107zm3.286-3.167a1.6 1.6 0 0 0-1.19 1.26l-.305 1.623-.303-1.623a1.6 1.6 0 0 0-1.19-1.26l-1.302-.32 1.302-.32a1.6 1.6 0 0 0 1.19-1.26l.303-1.623.306 1.623a1.6 1.6 0 0 0 1.189 1.26l1.302.32z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const DynatraceIntelligenceSignetIcon = /* @__PURE__ */ Object.assign(
  DynatraceIntelligenceSignetIconComponent,
  { displayName: 'DynatraceIntelligenceSignetIcon' },
);
